import { createRouter, createWebHistory, isNavigationFailure, NavigationFailureType, RouteRecordNameGeneric } from 'vue-router';
import Route from './route';
import { useInitialLoadingStore } from '../stores/initialLoadingStore';

declare module 'vue-router' {
    interface RouteMeta {
        title?: RouteRecordNameGeneric;
        navigationId?: number;
    }
}

let router = createRouter(
{
    history: createWebHistory(),
    routes: Route.toRouteRecordRaw()
});

router.afterEach((to, from, failure) =>
{
    // Ensures loading always gets hidden regardless of the multiguard results
    useInitialLoadingStore().hide();

    if (isNavigationFailure(failure, NavigationFailureType.duplicated))
    {
        router.push({ ...to, force:true, replace:true });
    }
});
router.beforeEach((to, from, next) =>
{
    if (to.fullPath === from.fullPath) {
        to.meta.navigationId = from.meta.navigationId ?? 0;
        to.meta.navigationId += 1;
    }
    return next();
});

export default router
